import mobileCoutries from '@intelligence/components/DownloadCommon/DownloadPage/configs/mobileCoutries';
import pcConsoleGameNew from '@intelligence/components/DownloadCommon/DownloadPage/configs/pcConsoleGameNew';
import pcConsoleTopCharts from '@intelligence/components/DownloadCommon/DownloadPage/configs/pcConsoleTopCharts';
import databrainCalibrationPCConsoleTopCharts from '@intelligence/components/DownloadCommon/DownloadPage/configs/databrainCalibrationPCConsoleTopCharts';
import alineaAnalyticsCalibrationPCConsoleTopCharts from '@intelligence/components/DownloadCommon/DownloadPage/configs/alineaAnalyticsCalibrationPCConsoleTopCharts';
import mobileStoreRankMore from '@intelligence/components/DownloadCommon/DownloadPage/configs/mobileStoreRankMore';
import consoleStoreRankMore from '@intelligence/components/DownloadCommon/DownloadPage/configs/consoleStoreRankMore';
import mobileStoreRankTop from '@intelligence/components/DownloadCommon/DownloadPage/configs/mobileStoreRankTop';
import consoleStoreRankTop from '@intelligence/components/DownloadCommon/DownloadPage/configs/consoleStoreRankTop';
import weixinStoreRankMore from '@intelligence/components/DownloadCommon/DownloadPage/configs/weixinStoreRankMore';
import competitors from '@intelligence/components/DownloadCommon/DownloadPage/configs/competitors';
import steamNews from '@intelligence/components/DownloadCommon/DownloadPage/configs/steamNews';
import pcConsoleRankTrend from '@intelligence/components/DownloadCommon/DownloadPage/configs/pcConsoleRankTrend';
import pcConsoleMarketCount from '@intelligence/components/DownloadCommon/DownloadPage/configs/pcConsoleMarketCount';
import mobileMarketProfileTopCharts from '@intelligence/components/DownloadCommon/DownloadPage/configs/mobileMarketProfileTopCharts';
import combineMarketProfileTopCharts from '@intelligence/components/DownloadCommon/DownloadPage/configs/marketProfileTopChartsCombine';
import marketProfileStats from '@intelligence/components/DownloadCommon/DownloadPage/configs/marketProfileStats';
import marketProfileStatsNew from '@intelligence/components/DownloadCommon/DownloadPage/configs/marketProfileStatsNew';
import pcConsoleRankTable from '@intelligence/components/DownloadCommon/DownloadPage/configs/pcConsoleRankTable';
import genreProfileTopCharts from '@intelligence/components/DownloadCommon/DownloadPage/configs/genreProfileTopCharts';
import genreProfileDetailStats from '@intelligence/components/DownloadCommon/DownloadPage/configs/genreProfileStats';
import pcConsoleDetail from '@intelligence/components/DownloadCommon/DownloadPage/configs/pcConsoleDetail';
import pcConsoleDetailSteamOverlap from '@intelligence/components/DownloadCommon/DownloadPage/configs/pcConsoleDetailSteamOverlap';
import mobileTopChartsRPD from '@intelligence/components/DownloadCommon/DownloadPage/configs/mobileTopChartsRPD';
import trueAllDataDownloadExcel from '@intelligence/components/DownloadCommon/DownloadPage/configs/trueAllDataDownloadExcel';
import mobileTopChartsMultiDataSource from '@intelligence/components/DownloadCommon/DownloadPage/configs/mobileTopChartsMultiDataSource';
import mobileOverlapTopCharts from '@intelligence/components/DownloadCommon/DownloadPage/configs/mobileOverlapTopCharts';
import mobileOverlapDetails from '@intelligence/components/DownloadCommon/DownloadPage/configs/mobileOverlapDetails';
import combineStatsAllMetrics from '@intelligence/components/DownloadCommon/DownloadPage/configs/combineStatsAllMetrics';
import combineStatsSteamData from '@intelligence/components/DownloadCommon/DownloadPage/configs/combineStatsSteamData';
import casualGenreProfile from './casualGenreProfile';
import casualCompetitorsKeyGames from './casualCompetitorsKeyGames';
import casualCompetitorsTopPublishers from './casualCompetitorsTopPublishers';
import robloxGameRank from './robloxGameRank';
import robloxTopCharts from './robloxTopCharts';
import minigameDetailsStoreRank from './minigameDetailsStoreRank';

const ExcelConfig: Record<string, any> = {
  mobileCoutries,
  pcConsoleGameNew,
  pcConsoleTopCharts,
  databrainCalibrationPCConsoleTopCharts,
  alineaAnalyticsCalibrationPCConsoleTopCharts,
  mobileStoreRankMore,
  consoleStoreRankMore,
  mobileStoreRankTop,
  consoleStoreRankTop,
  weixinStoreRankMore,
  competitors,
  steamNews,
  pcConsoleRankTrend,
  pcConsoleMarketCount,
  pcConsoleRankTable,
  mobileMarketProfileTopCharts,
  combineMarketProfileTopCharts,
  marketProfileStats,
  marketProfileStatsNew,
  genreProfileTopCharts,
  genreProfileDetailStats,
  pcConsoleDetail,
  pcConsoleDetailSteamOverlap,
  mobileTopChartsRPD,
  trueAllDataDownloadExcel,
  mobileTopChartsMultiDataSource,
  mobileOverlapTopCharts,
  mobileOverlapDetails,
  combineStatsAllMetrics,
  combineStatsSteamData,
  casualGenreProfile,
  casualCompetitorsKeyGames,
  casualCompetitorsTopPublishers,
  robloxGameRank,
  robloxTopCharts,
  minigameDetailsStoreRank,
};

export default ExcelConfig;
